import { create } from "zustand";
import { _Componentes_WebApiCalls_Post } from "../../ComponentesGlobales/WebApiCalls";
import { useStoreHome } from "../Home/useStoreHome";
import moment from "moment";
import { MensajeError, MensajeToastExito } from "../../componentes/FuncionesLocales";

export const useStoreSalidas = create((set, get) => {
  return {
    Proceso: "",
    Mercaderia: "",
    Lote: "",
    Fecha: new Date(),
    Unidades: 1,
    Kilos: "",
    FechaVencimiento: null,
    Etiquetas: 1,
    Procesando: false,
    TabSeleccionado: 0,
    SalidaOk: false,
    _barrasReqId: 0,
    FechasConSalidas: [],
    

    getUnidadPorDefecto: async () => {
      if (!useStoreHome.getState().EmpresaId || !get().Mercaderia || get().Mercaderia.Id <= 0) { return; }
      const sParametros = { EmpresaId: useStoreHome.getState().EmpresaId, Id: get().Mercaderia.Id };
      try {
        const data = await _Componentes_WebApiCalls_Post("Mercaderias/GetUnidadPorMercaderia", sParametros);
        if (data.error) {
        } else {
          set({ Unidad: data.data });
        }
      }
      catch (error) {
      }
    },

    ListaUnidades: [],
    buscandoUnidades: false,
    getUnidades: async () => {
      if (!useStoreHome.getState().EmpresaId || get().buscandoUnidades) { return; }
      const sParametros = { EmpresaId: useStoreHome.getState().EmpresaId };
      set({ buscandoUnidades: true });
      try {
        const data = await _Componentes_WebApiCalls_Post("Combos/Unidades", sParametros);
        if (data.error) {
          MensajeError(data.error);
        } else {
          set({ ListaUnidades: data.data.Lista });
        }
      }
      catch (error) {
        MensajeError(error.message);
      } finally {

      }
      set({ buscandoUnidades: false });
    },

    limpiar: (opts = {}) => {
      const keepFecha = opts.keepFecha ?? true;
      const keepTab = opts.keepTab ?? true;
      set((state) => ({

        Mercaderia: null,
        Lote: "",
        Unidades: 1,
        Kilos: "",
        FechaVencimiento: null,
        ...(keepFecha ? {} : { Fecha: new Date() }),
        ...(keepTab ? { TabSeleccionado: state.TabSeleccionado } : { TabSeleccionado: 0 }),
      }));
    },

    limpiezaTotal: (opts = {}) => {
      const keepFecha = opts.keepFecha ?? true;
      const keepTab = opts.keepTab ?? true;
      set((state) => ({
        Proceso: "",
        Mercaderia: null,
        Lote: "",
        Etiquetas: 1,
        Unidades: 1,
        Kilos: "",
        FechaVencimiento: null,
        ...(keepFecha ? {} : { Fecha: new Date() }),
        ...(keepTab ? { TabSeleccionado: state.TabSeleccionado } : { TabSeleccionado: 0 }),
      }));
    },

    eliminarSalida: async (id) => {
      if (get().procesando) { return; }
      set({ procesando: true });
      const data = await _Componentes_WebApiCalls_Post("PISeunProduccion/EliminarSalida", { id });
      if (data.error) {
        MensajeError(data.error);
      } else {
        MensajeToastExito("Salida eliminada correctamente");
        get().getFechas();
      }
      set({ procesando: false });
    },

    ListaProcesos: [],
    BuscandoProcesos: false,
    getProcesos: async () => {
      if (!useStoreHome.getState().EmpresaId || get().BuscandoProcesos) { return; }
      const sParametros = { EmpresaId: useStoreHome.getState().EmpresaId };
      set({ BuscandoProcesos: true });
      try {
        const data = await _Componentes_WebApiCalls_Post("Combos/ProcesosCliente", sParametros);
        if (data.error) {
          MensajeError(data.error);
        } else {
          set({ ListaProcesos: data.data.Lista.filter(p => p.sDescripcion?.toLowerCase().trim() !== 'faena') });
        }
      }
      catch (error) {
        MensajeError(error.message);
      } finally {

      }
      set({ BuscandoProcesos: false });

    },

    ListaMercaderias: [],
    Procesando: false,
    BuscandoMercaderia: false,
    getMercaderia: async () => {
      if (!useStoreHome.getState().EmpresaId || get().BuscandoMercaderia) { return; }
      const sParametros = { EmpresaId: useStoreHome.getState().EmpresaId, iFiltro: 20 };
      set({ BuscandoMercaderia: true });
      try {
        const data = await _Componentes_WebApiCalls_Post("Combos/MercaderiasFiltradasxTipos", sParametros);
        if (data.error) {
          MensajeError(data.error);
        } else {
          set({ ListaMercaderias: data.data.Lista });
        }
      }
      catch (error) {
        MensajeError(error.message);
      } finally {

      }
      set({ BuscandoMercaderia: false });

    },

    SalidaOk: false,
    Procesando: false,
    insert: async () => {
      if (!useStoreHome.getState().EmpresaId || get().Procesando) return;

      const fechaStr = moment(new Date(get().Fecha)).format("YYYY-MM-DD");
      const sParametros = {
        Proceso: get().Proceso && get().Proceso.Id ? get().Proceso : { Id: 0, sDescripcion: get().Proceso },
        Mercaderia: get().Mercaderia && get().Mercaderia.Id ? get().Mercaderia : { Id: 0, sDescripcion: get().Mercaderia },
        Lote: get().Lote && get().Lote.sDescripcion ? get().Lote.sDescripcion : '',
        Cantidad: get().Unidades,
        Peso: get().Kilos,
        FechaVencimiento: get().FechaVencimiento ? moment(get().FechaVencimiento).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
        Etiquetas: get().Etiquetas,
        FechaProduccion: fechaStr,
        EmpresaId: useStoreHome.getState().EmpresaId,
        OperadorId: Number(localStorage.getItem("OperadorId") ?? localStorage.getItem("Id") ?? 0),
        Unidad: get().Unidad && get().Unidad.Id ? get().Unidad : { Id: 0, sDescripcion: get().Unidad },
      };

      set({ Procesando: true });
      try {
        const data = await _Componentes_WebApiCalls_Post("Etiquetado/InsertEtiquetaPiSeun", sParametros);
        if (data?.error) {
          MensajeError(data.error);
        } else {
          get().limpiar({ keepFecha: true, keepTab: true });
          get().getUnidades();
          get().getProcesos();
          get().getMercaderia();
          get().getBarrasGrillaPantalla();
          MensajeToastExito("Se ingresaron los productos correctamente");
          get().getFechas();
          set({ SalidaOk: true, TabSeleccionado: 1 });
        }
      } catch (error) {
        MensajeError(error.message);
      } finally {
        set({ Procesando: false });
      }
    },

    ListaBarras: [],
    BuscandoBarras: false,

    getBarrasGrillaPantalla: async () => {
      if (!useStoreHome.getState().EmpresaId) return;
      if (get().BuscandoBarras) return;

      const reqId = (get()._barrasReqId || 0) + 1;
      set({ _barrasReqId: reqId });

      const sParametros = {
        FechaProduccion: moment(get().Fecha).format("YYYY-MM-DD"),
        EmpresaId: useStoreHome.getState().EmpresaId,
        Fecha: moment(get().Fecha).format("YYYY-MM-DD"),
        FechaHasta: moment(get().Fecha).format("YYYY-MM-DD"),
      };
      set({ BuscandoBarras: true });
      try {
        const data = await _Componentes_WebApiCalls_Post("Etiquetado/ListaDetalleCodbarPorFecha", sParametros);
        if (data?.error) {
          MensajeError(data.error);
        } else if (get()._barrasReqId === reqId) {
          const lista = data?.data?.Lista ?? data?.Lista ?? [];
          set({ ListaBarrasGrilla: Array.isArray(lista) ? lista : [] });
        }

      }
      catch (error) {
        MensajeError(error.message);
      } finally {

      }
      set({ BuscandoBarras: false });
    },


    getBarrasReporte: async (fechaOverride, fechaHastaOverride) => {
      if (!useStoreHome.getState().EmpresaId) return;
      if (get().BuscandoBarras) return;

      const reqId = (get()._barrasReqId || 0) + 1;
      set({ _barrasReqId: reqId });

      

      const sParametros = {
        FechaProduccion: moment(fechaOverride).format("YYYY-MM-DD"),
        EmpresaId: useStoreHome.getState().EmpresaId,
        Fecha: moment(fechaOverride).format("YYYY-MM-DD"),
        FechaHasta: moment(fechaHastaOverride).format("YYYY-MM-DD"),
      };

      


      set({ BuscandoBarras: true });
      try {
        const data = await _Componentes_WebApiCalls_Post("Etiquetado/ListaDetalleCodbarPorFecha", sParametros);
        if (data?.error) {
          MensajeError(data.error);
        } else if (get()._barrasReqId === reqId) {
          const lista = data?.data?.Lista ?? data?.Lista ?? [];
          set({ ListaBarras: Array.isArray(lista) ? lista : [] });
        }

      }
      catch (error) {
        MensajeError(error.message);
      } finally {

      }
      set({ BuscandoBarras: false });
    },


    EliminoOk: false,
    Eliminando: false,
    Seleccionados: [],
    eliminar: async (recordsParam, ctx = {}) => {
      if (!useStoreHome.getState().EmpresaId || get().Eliminando) return;

      const raw = Array.isArray(recordsParam) && recordsParam.length
        ? recordsParam
        : (get().Seleccionados || []);
      if (!raw.length) {
        MensajeError("No hay elementos seleccionados.");
        return;
      }

      const normalizados = raw.map(item => {
        if (typeof item === "number") {
          return { IdentificadorId: item, IndentificadorId: item };
        }
        const id = item?.IdentificadorId ?? item?.IndentificadorId ?? item?.id;
        return id ? { ...item, IdentificadorId: id, IndentificadorId: id } : item;
      });

      const fechaStr = moment(new Date(get().Fecha)).format("YYYY-MM-DD");
      const sParametros = {
        EmpresaId: useStoreHome.getState().EmpresaId,
        OperadorId: Number(localStorage.getItem("OperadorId") ?? localStorage.getItem("Id") ?? 0),
        Barras: JSON.stringify(normalizados),
        ...(ctx?.ProcesoId ? { ProcesoId: ctx.ProcesoId } : {}),
        ...(ctx?.MercaderiaId ? { MercaderiaId: ctx.MercaderiaId } : {}),
      };

      set({ Eliminando: true });
      try {
        const data = await _Componentes_WebApiCalls_Post("Etiquetado/EliminarBarras", sParametros);
        if (data?.error) {
          MensajeError(data.error);
        } else {
          set({ Seleccionados: [] });
          get().getBarrasGrillaPantalla();
          get().getFechas();
          set({ SalidaOk: true });
        }
      } catch (error) {
        MensajeError(error.message);
      } finally {
        set({ Eliminando: false });
      }
    },

    buscandoFechas: false,
    getFechas: async () => {
      if (!useStoreHome.getState().EmpresaId || get().buscandoFechas) { return; }
      const sParametros = { EmpresaId: useStoreHome.getState().EmpresaId };
      set({ buscandoFechas: true });
      try {
        const data = await _Componentes_WebApiCalls_Post("Etiquetado/DistintasFechas", sParametros);

        if (data.error) {
        } else {
          var fechas = [];
          for (const item of data.data.Lista) {
            if (item.Fecha) {
              fechas.push(new Date(item.Fecha))
            }
          }
          set({ FechasConSalidas: fechas });
        }
      }
      catch (error) {
      } finally {

      }
      set({ buscandoFechas: false });

    },

    BuscandoLotes: false,
    ListaLotes: null,
    getLotes: async () => {
      if (!useStoreHome.getState().EmpresaId || get().BuscandoLotes) { return; }
      const sParametros = {
        Fecha: moment(get().Fecha ? get().Fecha : new Date()).format("YYYY-MM-DD"),
        EmpresaId: useStoreHome.getState().EmpresaId
      };
      set({ BuscandoLotes: true });
      try {

        const data = await _Componentes_WebApiCalls_Post("Etiquetado/DistintosLotesEntradas", sParametros);

        if (data.error) {
        } else {
          set({ ListaLotes: data.data.Lista });
        }
      }
      catch (error) {
      } finally {
        set({ BuscandoLotes: false });
      }
    },

  };
});
